
declare var Object: any;
export interface TripSignatureCountInterface {
  "id"?: string;
  "vdate"?: any;
  "tenantId": number;
  "count"?: number;
  "units"?: number;
}

export class TripSignatureCount implements TripSignatureCountInterface {
  "id": string;
  "vdate": any;
  "tenantId": number;
  "count": number;
  "units": number;
  constructor(data?: TripSignatureCountInterface) {
    Object.assign(this, data);
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `TripSignatureCount`.
   */
  public static getModelName() {
    return "TripSignatureCount";
  }

  /**
  * This method creates an instance of TripSignatureCount for dynamic purposes.
  **/
  public static factory(data: TripSignatureCountInterface): TripSignatureCount{
    return new TripSignatureCount(data);
  }

  /**
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TripSignatureCount',
      plural: 'TripSignatureCounts',
      path: 'TripSignatureCounts',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "vdate": {
          name: 'vdate',
          type: 'any'
        },
        "tenantId": {
          name: 'tenantId',
          type: 'number'
        },
        "count": {
          name: 'count',
          type: 'number'
        },
        "units": {
          name: 'units',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
